import React from 'react';

export const Icon = () => {
    return (
        <svg viewBox="0 0 18 16" width="18px" xmlns="http://www.w3.org/2000/svg">
            <g fill="#0B1F35" transform="translate(-238.000000, -303.000000)">
                <g transform="translate(238.000000, 303.000000)">
                    <path d="M8,0 C3.588,0 0,3.588 0,8 C0,12.412 3.588,16 8,16 C12.412,16 16,12.412 16,8 C16,3.588 12.412,0 8,0 Z M8,14.933 C4.1728374,14.9285915 1.07140854,11.8271626 1.067,8 C1.07140854,4.1728374 4.1728374,1.07140854 8,1.067 C11.8271626,1.07140854 14.9285915,4.1728374 14.933,8 C14.9285915,11.8271626 11.8271626,14.9285915 8,14.933 Z" />
                    <path d="M7.067,4.475 C7.067,4.958 7.488,5.351 7.996,5.351 C8.513,5.351 8.933,4.958 8.933,4.475 C8.933,4.002 8.512,3.609 7.996,3.609 C7.488,3.609 7.066,4.002 7.066,4.475 L7.067,4.475 Z M7.467,6.969 L8.534,6.969 L8.534,11.947 L7.467,11.947 L7.467,6.969 Z" />
                </g>
            </g>
        </svg>
    );
};
